<div class="edit-question" [class.isLiveEvent]="questionId">
  <form [formGroup]="form">
    <qa-content-spinner [active]="loading" [class.preventOverflow]="questionId">
      <ng-container *ngTemplateOutlet="title"> </ng-container>
      <div class="content-question">
        <ng-container *ngTemplateOutlet="main"> </ng-container>
      </div>
    </qa-content-spinner>
    <ng-template #title> </ng-template>
    <ng-template #main>
      @if (showForm) {
      <div class="main-flex flex-row flex-auto-margin">
        @if (!showMobilePreview) {
        <mat-card appearance="outlined">
          <div class="question-header">
            @if (!isImport) { @if (!question && !duplicateQuestionId) {
            <h1 class="create-title">
              {{
                (form.value.id
                  ? 'question.editTitle'
                  : flashCardId
                  ? 'common.button.convertToQuestion'
                  : 'question.addTitle'
                ) | translate
              }}
            </h1>
            } } @if (question && duplicateQuestionId) {
            <h1 class="create-title">
              {{ 'question.duplicateQuestionTitle' | translate }}
            </h1>
            } @if (!isImport && !question && !form.value.id && !flashCardId) {
            <div class="template-select">
              <button
                mat-button
                type="button"
                [matMenuTriggerFor]="templateSelectMenu"
              >
                {{ 'common.button.useTemplate' | translate }}
                <img src="assets/icons/vorlage.png" alt="template" />
              </button>
              <mat-menu
                class="question-templates"
                #templateSelectMenu="matMenu"
              >
                @for (template of templates; track template.template) {
                <button
                  mat-menu-item
                  type="button"
                  (click)="useTemplate(template.template)"
                  [matTooltip]="template.title"
                >
                  {{ template.title }}
                </button>
                }
              </mat-menu>
            </div>
            }
          </div>
          @if (flashCardId) {
          <p class="explanation">
            {{ 'common.message.conversionHint.question' | translate }}
            <b>{{ 'common.message.conversionHint.question2' | translate }}</b>
            {{ 'common.message.conversionHint.question3' | translate }}
            <a
              target="_blank"
              href="https://quizacademy.de/tipps/content-konvertieren/"
            >
              {{ 'common.message.conversionHint.moreInfoLink' | translate }}.
            </a>
          </p>
          } @if (duplicateQuestionId) {
          <p class="explanation">
            {{ 'common.message.duplicateHint.question' | translate }}
          </p>
          }
          <ng-scrollbar>
            <div class="question-form" [ngClass]="{ create: !courseId }">
              <div class="form-header">
                @let questionType = question?.type ?? importQuestion?.type; @if
                (questionType > -1) {
                <h2>
                  {{
                    (isPollQuestion
                      ? 'question.label.surveyQuestionShort'
                      : 'question.label.quizQuestionShort'
                    ) | translate
                  }}
                  ({{ QuestionTypeDisplayFn(questionType, true) }})
                </h2>
                }
                <div class="flex-50">
                  @if (questionId) {
                  <div class="preview">
                    <qa-form-field-toggle
                      (valueChanged)="onValueChange($event)"
                      [label]="
                        'exam.users.accessRestriction.generateDialog.preview'
                          | translate
                      "
                    >
                    </qa-form-field-toggle>
                  </div>
                  }
                </div>
              </div>
              <div class="tabs-container">
                <qa-custom-tabs
                  [tabs]="questionsTypes"
                  [defaultSelected]="isPollQuestion ? 1 : 0"
                  (tabSelected)="getTypeVal($event)"
                ></qa-custom-tabs>
              </div>
              <div class="template-selection-section">
                <h3 class="selection-title">
                  {{ 'question.label.chooseQuestionType' | translate }}
                </h3>
                <div class="template-grid">
                  @for (template of templateType; track $index; let i = $index)
                  {
                  <div
                    class="template-card"
                    [class.active]="selectedTemplateIndex === i"
                    [class.disabled]="template.isDisabled"
                    [matTooltip]="template.isDisabled ? template.tooltip : ''"
                    (click)="selectTemplate(template, i)"
                  >
                    <div class="card-icon">
                      <mat-icon>{{ template.icon }}</mat-icon>
                    </div>
                    <div class="card-content">
                      <div class="card-title">{{ template.title }}</div>
                      <div class="card-description">
                        {{ template.description }}
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
              <div class="flex-100">
                <qa-media-input
                  [control]="form.get('media')"
                  [beforeUploadCallback]="editImagePreUpload"
                ></qa-media-input>
              </div>
              <qa-form-field-input
                [control]="form.get('text')"
                label="{{
                  (form.value.type === questionTypeEnum.FREETEXT
                    ? 'question.label.questionText'
                    : 'question.label.questionLabel'
                  ) | translate
                }}"
                [markdownHint]="true"
                [multi]="true"
                required="true"
                class="name-input"
                data-cy="questionField"
              >
              </qa-form-field-input>
              @if ( form.value.type === questionTypeEnum.FREETEXT &&
              !isPollQuestion ) {
              <qa-form-field-input
                [control]="form.get('sample_answer')"
                label="{{ 'question.label.sampleAnswer' | translate }}"
                [markdownHint]="true"
                [multi]="true"
                class="name-input"
                data-cy="question"
              >
              </qa-form-field-input>
              }
              <qa-content-spinner
                [active]="loadAnswers"
                [class.answer-box]="loadAnswers"
              >
                @if (showAnswers) {
                <ng-content *ngTemplateOutlet="answerForm"> </ng-content>
                }
              </qa-content-spinner>
              <qa-form-field-input
                [control]="form.get('explanation')"
                label="{{ 'question.form.explanation' | translate }}"
                [suggestion]="suggestion"
                [markdownHint]="true"
                [multi]="true"
                data-cy="explanationField"
              >
              </qa-form-field-input>
              @if (!isPollQuestion) {
              <qa-form-field-input
                [control]="form.get('weblink')"
                label="{{ 'question.form.webLink' | translate }}"
                data-cy="webLinkField"
              >
              </qa-form-field-input>
              } @if (!isPollQuestion) {
              <qa-form-field-input
                [control]="form.get('source')"
                label="{{ 'question.form.source' | translate }}"
                data-cy="sourceField"
              >
              </qa-form-field-input>
              }
              <qa-tag-input
                [control]="form.get('tags')"
                label="{{ 'Tags' | translate }}"
                data-cy="tagsField"
              >
              </qa-tag-input>
              <div
                class="hint-text"
                [innerHTML]="
                  'question.form.tagHint.questionsAndFlashcardsCategorized'
                    | translate
                "
              ></div>
              <div class="save-hint">
                <p [innerHTML]="'common.message.saveHintText' | translate"></p>
              </div>
            </div>
          </ng-scrollbar>
        </mat-card>
        } @if (!questionId || (questionId && showMobilePreview)) {
        <div
          class="mock-phone-container"
          [class.showMobilePreview]="showMobilePreview"
        >
          @if (questionId) {
          <div class="preview mobile">
            <qa-form-field-toggle
              (valueChanged)="onValueChange($event)"
              [checked]="true"
              [label]="
                'exam.users.accessRestriction.generateDialog.preview'
                  | translate
              "
            >
            </qa-form-field-toggle>
          </div>
          }
          <ng-scrollbar>
            @if (!loading) {
            <div
              class="mock-phone"
              [ngClass]="{ create: !question || duplicateQuestionId }"
            >
              <qa-question-mock-phone
                [currentItemPosition]="currentIndex + 1"
                [itemCount]="totalItems"
                [question]="form.value"
                [displayAnswersInOrder]="form.value.display_in_order"
                [isPollQuestion]="isPollQuestion"
                [isExam]="parentExamId"
                [brandingColor]="exam?.color_code"
              ></qa-question-mock-phone>
            </div>
            }
          </ng-scrollbar>
          @if (!showMobilePreview) {
          <div
            class="flex-column flex-align-items-center flex-justify-content-center"
          >
            @if ( ((courseId || questionIdFromContent) && question &&
            form.value.id) || isImport ) {
            <qa-import-csv-navigation
              [currentItemPosition]="currentIndex + 1"
              [itemCount]="totalItems"
              (navigation)="onNavigate($event)"
              [disabledNavigation]="form.invalid"
              [isImport]="isImport"
            >
            </qa-import-csv-navigation>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </ng-template>
    @if (!loading) {
    <div class="actions">
      <ng-content select="[actionButtons]">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </ng-content>
    </div>
    }
    <ng-template #answerForm>
      <div
        class="answers-container"
        [class.freetext]="form.value.type === questionTypeEnum.FREETEXT"
        [class.poll-question]="isPollQuestion"
      >
        @if ( form.value.type === questionTypeEnum.TRUE_FALSE) {
        <qa-form-field-toggle
          data-cy="trueFalseToggle"
          [control]="form.get('is_right')"
          (valueChanged)="changeRightAnswer()"
          label="{{ 'question.form.correct' | translate }}"
          prefixLabel="{{ 'question.form.inCorrect' | translate }}"
        >
        </qa-form-field-toggle>
        } @else { @if ( form.value.type === questionTypeEnum.FREETEXT) { @if
        (!isPollQuestion) {
        <qa-form-field-input
          [control]="form.get('max_score')"
          [step]="1"
          required="true"
          label="{{ 'question.form.maxScore' | translate }}"
          type="number"
          [allowDecimal]="false"
          data-cy="maxScore"
        ></qa-form-field-input>
        } @if (isPollQuestion) {
        <qa-form-field-input
          [control]="form.get('max_answer_submissions')"
          [step]="1"
          required="true"
          [hint]="'question.form.maxAnswerHint' | translate"
          label="{{ 'question.form.maxAnswerSubmissions' | translate }}"
          type="number"
          [allowDecimal]="false"
        ></qa-form-field-input>
        }
        <qa-form-field-input
          [control]="form.get('max_num_characters')"
          label="{{ 'question.form.maxCharacters' | translate }}"
          [step]="1"
          type="number"
          [allowDecimal]="false"
          data-cy="numberOfMaxCharacter"
          hint="{{ 'question.form.maxCharactersDetails' | translate }}"
        ></qa-form-field-input>
        } @else {
        <mat-radio-group [formControl]="radioRightAnswerControl">
          @for ( answer of form.get('answers')['controls']; track $index; let i
          = $index) {
          <div class="answer">
            <div class="flex-row flex-align-items-center flex-auto-margin">
              @if (form.value.type === questionTypeEnum.SINGLE_CHOICE) {
              <mat-radio-button
                [value]="answer"
                (click)="onSelectSingleChoiceAnswer(i)"
                [checked]="answer.get('is_right').value"
                color="primary"
              >
              </mat-radio-button>
              } @if (form.value.type === questionTypeEnum.MULTIPLE_CHOICE) {
              <mat-checkbox
                [formControl]="
                  form.get('answers')['controls'][i].get('is_right')
                "
                color="primary"
              >
              </mat-checkbox>
              }
              <qa-form-field-input
                [ngStyle]="{ margin: 0 }"
                [control]="form.get('answers')['controls'][i].get('text')"
                placeholder="{{ 'question.form.answer' | translate }}"
                [multi]="true"
                [markdownHint]="true"
                class="flex-grow"
                data-cy="answerInputField"
              >
              </qa-form-field-input>
              <div class="remove-ans" (click)="onRemoveAnswer(i)">
                <mat-icon>delete</mat-icon>
              </div>
            </div>
          </div>
          }
        </mat-radio-group>
        <div class="more-info">
          <div class="more-info-row1">
            <button
              (click)="onAddAnswer()"
              class="add-more"
              mat-button
              data-cy="addAnswer"
              type="button"
            >
              <mat-icon>add</mat-icon>
              {{ 'question.label.addMore' | translate }}
            </button>
            @if (form?.value.type !== questionTypeEnum.TRUE_FALSE) {
            <div class="checkbox-container">
              <mat-checkbox
                data-cy="displayInOrder"
                [formControl]="form.get('display_in_order')"
                color="primary"
              >
                {{ 'question.form.fixAnswer' | translate }}
              </mat-checkbox>
              <mat-icon class="info-tool-tip" (click)="openDialog()"
                >info</mat-icon
              >
            </div>
            }
          </div>
          @if (!isPollQuestion) {
          <div class="more-info-row2">
            <button
              (click)="onGenerateWrongAnswers()"
              class="add-more"
              [disabled]="!form.get('text').value"
              mat-button
              type="button"
            >
              <mat-icon>generating_tokens</mat-icon>
              {{ 'question.label.generateWrongAnswers' | translate }}
            </button>
            <qa-form-field-select
              [control]="generatedWrongAnswerStyleControl"
              [options]="generatedWrongAnswerStyles"
              [label]="
                'question.label.generatedWrongAnswerType.title' | translate
              "
              required="true"
              (ValueChanged)="onGeneratedWrongAnswerStyleChanged($event)"
              [displayFn]="displayWrongAnswerTypeOption"
            >
            </qa-form-field-select>
          </div>
          }
        </div>
        } }
      </div>
    </ng-template>
    <ng-template #actions>
      <div class="buttons">
        <div class="left-actions">
          @if (!questionId) { @if (question && !duplicateQuestionId) {
          <qa-button
            label="common.button.duplicate"
            (submitted)="duplicatedQuestion()"
          ></qa-button>
          } @if (question && !duplicateQuestionId && !isPollQuestion) {
          <qa-button
            label="common.button.convertToFlashCard"
            (submitted)="convertToFlashcard()"
          ></qa-button>
          } } @if (id) {
          <qa-button
            [matMenuTriggerFor]="moreMenu"
            [isIconButton]="true"
            icon="more_vert"
          ></qa-button>
          }
          <mat-menu
            class="material-menu"
            [overlapTrigger]="true"
            #moreMenu="matMenu"
          >
            @if (questionId) { @if (question && !duplicateQuestionId) {
            <button (click)="duplicatedQuestion()" mat-menu-item type="button">
              <mat-icon>copy</mat-icon>
              {{ 'common.button.duplicate' | translate }}
            </button>
            } @if (question && !duplicateQuestionId && !isPollQuestion) {
            <button (click)="convertToFlashcard()" mat-menu-item type="button">
              <mat-icon>crop</mat-icon>
              {{ 'common.button.convertToFlashCard' | translate }}
            </button>
            } } @if (hasComments) {
            <button (click)="showComments()" mat-menu-item type="button">
              <mat-icon>comment</mat-icon>
              {{ 'comment.label.showComment' | translate }}
            </button>
            }
            <button (click)="exportAsJson()" mat-menu-item type="button">
              <mat-icon>download</mat-icon>
              {{ 'content.course.actionMenu.downloadJSON' | translate }}
            </button>
            @if (form.value.id) {
            <button (click)="onDelete()" mat-menu-item type="button">
              <mat-icon>delete</mat-icon>
              {{ 'common.button.clear' | translate }}
            </button>
            }
          </mat-menu>
        </div>
        @if (!isImport) {
        <div class="flex-align-right">
          <qa-button
            data-cy="close"
            label="common.button.shutdown"
            (submitted)="onClose()"
          ></qa-button>
          @if (question || flashCardId) { @if (userId === question?.created_by
          || !question) {
          <qa-button
            [disabled]="
              form.invalid || form.pristine || (form && isAllAnswerUnchecked())
            "
            [isRaisedButton]="true"
            data-cy="save"
            label="common.button.save"
            (submitted)="onSubmit()"
          ></qa-button>
          } } @if (!question && !flashCardId) {
          <qa-button
            [matMenuTriggerFor]="addMenu"
            [disabled]="
              form.invalid || form.pristine || (form && isAllAnswerUnchecked())
            "
            [isRaisedButton]="true"
            label="common.button.save"
            #addButton
            data-cy="save"
          ></qa-button>
          }
          <mat-menu
            class="material-menu"
            [overlapTrigger]="true"
            #addMenu="matMenu"
          >
            @if (!form.value.id && !flashCardId && !duplicateQuestionId) {
            <button
              [disabled]="form.invalid || form.pristine"
              (click)="onSubmit(true)"
              mat-menu-item
              type="button"
            >
              <mat-icon>add</mat-icon>
              {{ 'common.button.saveAndNew' | translate }}
            </button>
            } @if (!form.value.id && !flashCardId && !duplicateQuestionId) {
            <button
              [disabled]="form.invalid || form.pristine"
              (click)="onSubmit(false, true)"
              mat-menu-item
              type="button"
            >
              <mat-icon>copy</mat-icon>
              {{ 'common.button.saveAndDuplicate' | translate }}
            </button>
            } @if (userId === question?.created_by || !question) {
            <button
              [disabled]="form.invalid || form.pristine"
              (click)="onSubmit()"
              mat-menu-item
              type="button"
              data-cy="saveAndClose"
            >
              <mat-icon>check</mat-icon>
              {{ 'common.button.saveAndClose' | translate }}
            </button>
            } @if (question && userId !== question?.created_by) {
            <button
              [disabled]="form.invalid || form.pristine"
              matTooltipClass="preline"
              matTooltip="{{ 'question.form.unlinkSaveTooltip' | translate }}"
              (click)="unlinkQuestion()"
              mat-menu-item
              type="button"
            >
              <mat-icon class="material-icons">shopping_cart</mat-icon>
              {{ 'question.form.unlinkSave' | translate }}
            </button>
            }
          </mat-menu>
        </div>
        }
      </div>
    </ng-template>
  </form>
</div>
